<template>
<v-app>
<v-card
    color="grey lighten-4"
    flat
    tile
  >
    <v-toolbar
      color="topBarBg accent-4"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>Penta Sinergi Group</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        @click="logout()"
        text
      >
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-toolbar>
</v-card>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list
        nav
        dense
      >
      <!-- <v-list-group v-for="item in items" :value="item.active" :key="item.title">
          {{item}}
          <v-list-tile slot="item" 
                       :to="item.path == '#' ? '' : item.path" 
                       :exact="item.exact" 
                       class="yellow--text"
                       active-class="red--text">
            <v-list-tile-action>
              <v-icon>{{ item.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title >{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="item.items.length > 0">
              <v-icon>keyboard_arrow_down</v-icon>
            </v-list-tile-action>
          </v-list-tile>         
        </v-list-group> -->
<!-- 
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list> -->
                <v-list-item v-for="item in items" :key="item.title" link :to="item.href" >
                    <v-list-item-icon>
                        <v-icon color="purple">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{item.title}}</v-list-item-title>
                </v-list-item>
        <!-- </v-list-item-group> -->
      </v-list>
    </v-navigation-drawer>

    <v-main>
        <v-container fluid>
      <router-view/>
      </v-container>
    </v-main>
</v-app>
</template>

<script>
  export default {
    data: () => ({
      drawer: false,
      group: null,
      items: [
          
      { title: "Home", href: "/admin/home", icon: "mdi-home-outline" },
      // { title: "List Hadiah", href: "/admin/hadiah", icon: "mdi-account-circle" },
      { title: "Survey", href: "/admin/survey", icon: "mdi-palette-swatch" },
      // { title: "SpinWheel", href: "/admin/spin",icon: "mdi-account-search-outline"},
      // { title: "Map Employee", href: "/admin/maps",icon: "mdi-map-outline"},
      { title: "Slot Machine", href: "/admin/slot", icon: "mdi-bus-clock" }
    ]
    }),

    watch: {
      group () {
        this.drawer = false
      },
    },
    methods:{
    logout(){
      this.$store.commit('SET_LOGIN',null) 
        this.$router.push('/')      
    }
  }
  }
</script>